'use client'

import { Dialog } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  show: boolean
  theme?: 'primary' | 'warning'
  translationsPrefix: string
  onConfirm: () => void
  onCancel: () => void
}

const ConfirmModal = ({
  show,
  theme = 'primary',
  translationsPrefix,
  onConfirm,
  onCancel,
}: Props) => {
  const translate = useTranslate(translationsPrefix)

  return (
    <Dialog
      show={show}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('buttons.confirm'),
          style: Dialog.ActionStyling.Filled,
          theme,
          callback: onConfirm,
          testId: 'confirm-button',
        },
        {
          text: translate('buttons.cancel'),
          style: Dialog.ActionStyling.Flat,
          callback: onCancel,
        },
      ]}
    />
  )
}

export default ConfirmModal
